import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import {
    TActionType,
    TransactionType,
} from '../../Utility/Tracking/DataSet/Transaction';
import { trackTransaction } from '../../Utility/Tracking/TrackingHelpers/Transaction';
import GameStateHelper from '../Game/GameStateHelper';
import { ContextType } from '../Game/IContext';
import { IGameState } from '../Game/IGameState';
import {
    getCompletedLevels,
    getCurrentLevelNumber,
} from '../Player/PlayerLevelHelper';
import { setStateTaskData } from '../Player/PlayerStateHelper';
import { PlayerTask } from '../Player/PlayerTasks';
import { hidePopup, queuePopup } from '../UI/UIStateHelper';
import {
    BotOptStatus,
    CrossPromoStatus,
    ShortcutStatus,
    UserActions,
} from './UserActions';

export const UserReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof UserActions>
): IGameState => {
    switch (action.type) {
        case getType(UserActions.dismissBot):
            return {
                ...state,
                userState: {
                    ...state.userState,
                    subscribeBot: BotOptStatus.DISMISSED,
                },
                UIState: hidePopup(state.UIState, 'botOptInMenu', null),
            };
        case getType(UserActions.dismissCrossPromo):
            return {
                ...state,
                userState: {
                    ...state.userState,
                    crossPromo: CrossPromoStatus.DISMISSED,
                },
                UIState: hidePopup(state.UIState, 'crossPromoMenu', null),
            };
        case getType(UserActions.dismissShortcut):
            return {
                ...state,
                userState: {
                    ...state.userState,
                    createShortcut: ShortcutStatus.DISMISSED,
                },
                UIState: hidePopup(state.UIState, 'createShortcutMenu', null),
            };
        case getType(UserActions.purchaseItem):
            return {
                ...GameStateHelper.setContext(
                    state,
                    ContextType.PURCHASE_PRODUCT,
                    action.payload
                ),
            };
    }
    return state;
};

/**
 * Check if cross-promo should be enabled.
 * @param state
 */
export function checkCrossPromo(state: IGameState): IGameState {
    if (
        state.userState.crossPromo !== CrossPromoStatus.DISMISSED &&
        state.platform.crossPromoSupport &&
        getCurrentLevelNumber(state) > 20
    ) {
        return {
            ...state,
            userState: {
                ...state.userState,
                crossPromo: CrossPromoStatus.ENABLED,
            },
        };
    }

    return state;
}

/**
 * Check if bot subscribe should be enabled.
 * @param state
 */
export function checkBotOptIn(state: IGameState): IGameState {
    if (
        state.userState.subscribeBot !== BotOptStatus.DISMISSED &&
        state.userState.subscribeBot !== BotOptStatus.SUBSCRIBED
    ) {
        return {
            ...state,
            userState: {
                ...state.userState,
                subscribeBot:
                    state.platform.subscribeBot &&
                    getCompletedLevels(state.playerState.levels.saga).length > 3
                        ? BotOptStatus.ENABLED
                        : BotOptStatus.DISABLED,
            },
        };
    }

    return state;
}

/**
 * Check if player should be shown the create-shortcut menu.
 * @param state
 */
export function checkCreateShortcut(state: IGameState): IGameState {
    if (
        state.userState.createShortcut === ShortcutStatus.ENABLED &&
        (state.levelState.levelNumber === 5 ||
            state.playerState.world > state.previousState.playerState.world)
    ) {
        if (state.playerState.shortcutReward === 0) {
            // Player has not received the reward yet show the in-game pop-up.
            return {
                ...state,
                UIState: queuePopup(state.UIState, 'createShortcutMenu', {}),
            };
        } else {
            // If the player already received the reward then just show the FB prompt via task.
            return {
                ...state,
                playerState: setStateTaskData(state.playerState, {
                    task: PlayerTask.CREATE_SHORTCUT,
                }),
            };
        }
    }

    return state;
}
